<template>
  <Breadcrumbs
      title="Distributor Stock Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Distributor Stock Report', path: '/distributor-stock-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <distributorStockReport />
    </div>
  </div>
</template>

<script>
import distributorStockReport from './distributorstockForm.vue'
export default {
  name: 'indexList',
  components: {
    distributorStockReport,
  },
}
</script>
